import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddServiceForm from './form/addForm';
import { createService } from './_api';
import { get } from 'lodash';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withRouter,
  withSnackbar,
  withHandlers({
    onSubmit: ({ history, toggleLoader, enqueueSnackbar }) => async values => {
      toggleLoader();
      const resp = await createService(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Služba byla úspěšně vytvořena.', { variant: 'success' });
        history.push('/services');
      } else {
        enqueueSnackbar('Službu se nepodařilo vytvořit.', { variant: 'error' });
      }
      toggleLoader(false);
    },
  }),
);

export default enhance(({ classes, onSubmit }) => (
  <div className={classes.root}>
    <h3>Přidat službu</h3>
    <Paper className={classes.paper}>
      <AddServiceForm onSubmit={onSubmit} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/services/add.js